export { DMS_MODULE } from '../constants';
export const NAME = 'WmsParking';
export const API_NAME = 'WmsParking';
export const CRUMB_LABEL_KEY = 'WmsParking';
